import axios from "axios";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_PANDOC_URL,
});

async function uploadFile(formData) {
  const response = await http.post("/convert", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
}

async function getFile(fileName) {
  const response = await http.get("/converted", {
    params: {
      filename: fileName,
    },
  });

  return response.data;
}

async function deleteFile(fileName) {
  const response = await http.delete("/delete", {
    params: {
      filename: fileName,
    },
  });

  return response.data;
}

export { uploadFile, getFile, deleteFile };
